import { PaymentType, RegistrationStatus } from '@/types/tournament.model';

/**
 * Gets label for a payment type
 */
export const getPaymentTypeLabel = (type: PaymentType | string): string => {
  const value = String(type).toUpperCase();
  if (value === PaymentType.MERCADOPAGO) return 'Solo Mercado Pago';
  if (value === PaymentType.CASH || value === 'CASH')
    return 'Solo efectivo / transferencia';
  if (value === PaymentType.ALL) return 'Mercado Pago y efectivo';

  return String(type);
};

/**
 * Gets label for a payment type
 */
export const getCommissionPaymentTypeLabel = (type: PaymentType): string => {
  if (type === PaymentType.MERCADOPAGO) return 'Mercado Pago';
  if (type === PaymentType.ALL || type === PaymentType.CASH) return 'Efectivo';

  // If it doesn't match any of the above cases, capitalize the first letter
  return type;
};

/** Etiqueta corta para UI (tarjetas): método con el que abonó o canal de pago. */
export function getShortPaymentMethodLabel(
  type: PaymentType | string | null | undefined,
): string {
  if (type == null || type === '') return '';
  const v = String(type).toUpperCase().replace(/-/g, '_');
  if (v === PaymentType.MERCADOPAGO) return 'Mercado Pago';
  if (v === PaymentType.CASH) return 'Efectivo';
  if (v === PaymentType.ALL) return 'Mercado Pago o efectivo';
  return String(type);
}

/**
 * Payment method shown on registration detail: prefers `registration.paymentMethod` from the API;
 * if missing and the registration is paid, falls back to the tournament's payment method.
 */
export function getRegistrationAbonoLabel(
  registration: {
    status: RegistrationStatus;
    paymentMethod?: PaymentType | null;
  },
  tournamentPaymentType?: PaymentType,
): string | undefined {
  const pm = registration.paymentMethod?.trim();
  if (pm) {
    const short = getShortPaymentMethodLabel(pm);
    return short || pm;
  }
  if (
    registration.status === RegistrationStatus.COMPLETE &&
    tournamentPaymentType != null
  ) {
    return getShortPaymentMethodLabel(tournamentPaymentType);
  }
  return undefined;
}
